// src/constants/resources.ts - Static resource URLs

export const PLUGIN_GUIDE_URL = '/cr3ate-plugin.pdf';
